import React, { useMemo } from 'react'
import { useGlobalFilter, usePagination, useSortBy, useTable, useRowSelect } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import { Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import { CustomStyleColumn } from 'components/Types/GeneralTypes';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import InterrupcionSVG from "assets/icons/Permisos/PerdidaEMBARAZO.svg"
import { downloadExcelReportEmbarazo } from './FunctionsNotificacionEmbarazoTh';
import ButtonAprobarMasivo from 'components/Varios/ButtonAprobarMasivo';



export default function TablaNotificacionEmbarazoTh({ dataFilas, onClickVerDocumento, onClickRechazar}) {

    const filas = useMemo(
        () => [...dataFilas], [dataFilas]
    )
    

    function GenerarCellAcciones(data) {
        const iconoDescargarSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Certificado"
                onClick={() => onClickVerDocumento(data.acciones.refArchivo)}
            >
                <img
                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Certificado"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Certificado"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )


        
        const iconoAnularSolicitud = (
            <i
                data-toggle="tooltip" data-placement="top" title="Rechazar Solicitud"
                onClick={() => onClickRechazar(data.acciones)}
            >
                <img
                    src={InterrupcionSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Rechazar Solicitud"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Rechazar Solicitud"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        )

        const contentAccion = (
            <React.Fragment>
                {iconoDescargarSolicitud}
                {data.acciones.fechaInterrupcion === null && iconoAnularSolicitud}

            </React.Fragment>
        )
        return contentAccion
    }

    const columnas:any = React.useMemo(
        () => [
            {
                Header: "Identificación",
                accessor: "numeroIdentificacion"
            },
            {
                Header: 'Nombres',
                accessor: 'nombres',
            },
            {
                Header: 'Fecha Certificado',
                accessor: 'fechaCertificado',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: 'Fecha Estimada Parto',
                accessor: 'fechaEstimadaParto',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            ,
            {
                Header: 'Fecha Interrupción',
                accessor: 'fechaInterrupcion',
                Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
            },
            {
                Header: "Acciones",
                accessor: (row) => ({
                    acciones: row,
                }),
                Cell: ({ value }) => GenerarCellAcciones(value)
            },
        ], [dataFilas]
    )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
        {
            HeaderName: "Identificación",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: 'Acciones',
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Nombres",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Certificado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Estimada Parto",
            StyleHeader: {
                textAlign: "center"
            }
        }
        ,
        {
            HeaderName: "Fecha Interrupción",
            StyleHeader: {
                textAlign: "center"
            }
        }
    ]

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        visibleColumns,
        prepareRow,
        state,
        setGlobalFilter
    } = useTable(
        {
            columns: columnas,
            data: filas
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [
                    // {
                    //     id: 'selection',
                    //     Header: ({ getToggleAllPageRowsSelectedProps }) => (
                    //         <Checkbox
                    //             isHeader={true}
                    //             {...getToggleAllPageRowsSelectedProps()}
                    //         />
                    //     ),
                    //     Cell: ({ row }) => (
                    //         <Checkbox
                    //             condition={ShowCheckBoxCondition(row.values)}
                    //             {...row.getToggleRowSelectedProps()}

                    //         />
                    //     )

                    // },
                    ...columns
                ]
            })
        }
    )

    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = filas.length;


    function ShowCheckBoxCondition(dataRow) {
        return dataRow ;
    }


    return (
        <React.Fragment>
            {/* <Row>
                <Col xl={2}>
                    <div className='containerBotonGenerarReporte'>
                        <Button className="fleft" onClick={() => downloadExcelReportEmbarazo()}> GENERAR REPORTE </Button>
                    </div>
                </Col>
                <Col xl={10}>
                    <GlobalFilterTable
                        filter={globalFilter}
                        setFilter={setGlobalFilter}
                    />
                </Col>
            </Row> */}
            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                        <GlobalFilterTable
                            filter={globalFilter}
                            setFilter={setGlobalFilter}
                        />
                        {/* <div className='containerBotonAprobMasivaSolicitudes'> */}
                        <div className='containerBotonGenerarReporte'>
                            <ButtonAprobarMasivo
                                onClick={() => downloadExcelReportEmbarazo()}
                                text="GENERAR REPORTE"
                            />
                            {/* <Button className="fleft" onClick={() => downloadExcelReportEmbarazo()}> GENERAR REPORTE </Button> */}
                        </div>
                    </div>


                </Col>
                
            </Row>
            <Row>
                <Col xl={12}>
                    <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                        <thead style={{}}>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className='clickable'
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>

                                        {row.cells.map(cell => {
                                            return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow, columnasStyles(cell))

                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}

                    />
                </Col>
            </Row>



        </React.Fragment>
    )
}